// NPM Imports
import React, { Component, Fragment } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loader, Toastr, Tooltip, Button } from "@revvsales/components";

// Components Imports

// Action Imports
import { AssetActions } from "../../../../actions";

// Methods Imports
import { checkAssetPermission } from "../../method";

// Internal Imports
import { GlobalUtils } from "../../../../utils";
import { ASSET, LOADING_MSG } from "../../../../constants";

// Destructuring
const { moveToAssetItemsAction } = AssetActions;
const { handleApiErrMsg, truncateString } = GlobalUtils;
const { ASSET_TOASTR_MESSAGE } = ASSET;
const {
  ASSET: { MOVE_FOLDER },
} = LOADING_MSG;

class AssetMoveToFolderPopup extends Component {
  state = {
    showButtunLoader: false,
    selectedBredcrumb: null,
    breadcrumbData: [],
  };

  componentDidMount() {
    const { assetBreadcrumbData } = this.props;
    let selectedBredcrumb = null;
    if (assetBreadcrumbData && assetBreadcrumbData.length > 0) {
      selectedBredcrumb = assetBreadcrumbData[assetBreadcrumbData.length - 1];
    }
    this.setState({
      breadcrumbData: assetBreadcrumbData,
      selectedBredcrumb,
    });
  }

  _closePopup = () => {
    this.props.closePopup("showMoveToFolderPopup", false);
  };

  _handleFolderSelection = selectedFolderID => {
    const { breadcrumbData, selectedBredcrumb } = this.state;
    let tempBcData = null;
    if (selectedBredcrumb) {
      tempBcData = selectedBredcrumb.children.find(
        sbc => sbc.id === selectedFolderID,
      );
    }
    if (tempBcData) {
      const tempBreadcrumbData = [...breadcrumbData];
      tempBreadcrumbData.push(tempBcData);
      this.setState({
        breadcrumbData: tempBreadcrumbData,
        selectedBredcrumb: tempBcData,
      });
    }
  };

  _handleBredcrumbClick = bredcrumbId => {
    const { breadcrumbData } = this.state;
    let tempBcData = null;
    breadcrumbData.forEach((bc, index) => {
      if (bc.id === bredcrumbId) {
        tempBcData = {
          index,
          findBredcrumb: bc,
        };
      }
    });
    if (tempBcData) {
      const tempBreadcrumbData = breadcrumbData.slice(0, tempBcData.index + 1);
      this.setState({
        selectedBredcrumb: tempBcData.findBredcrumb,
        breadcrumbData: tempBreadcrumbData,
      });
    }
  };

  _moveAssetItemsHandler = () => {
    this.setState({ showButtunLoader: true });
    const { selectedItems } = this.props;
    const { selectedBredcrumb } = this.state;
    const payload = {
      ids: selectedItems.ids,
      to: selectedBredcrumb.id || null,
    };
    this.props
      .moveToAssetItems(payload, selectedItems)
      .then(() => {
        this.setState({ showButtunLoader: false });
        Toastr.showToastr({
          type: "success",
          message: ASSET_TOASTR_MESSAGE.FOLDER_MOVED,
          timeout: 3000,
        });
        this._closePopup();
      })
      .catch(error => {
        console.error(
          `AssetMoveToFolderPopup => _moveAssetItemsHandler => Error : ${error}`,
        );
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
        this.setState({
          showButtunLoader: false,
        });
      });
  };

  _activeBreadcrumbClassName = (id, index) => {
    const { selectedBredcrumb, breadcrumbData } = this.state;
    let className = "";
    if (selectedBredcrumb) {
      if (selectedBredcrumb.id === id) {
        className = "active-bredcrumb";
      }
    } else if (index === breadcrumbData.length - 1) {
      className = "active-bredcrumb";
    }

    return className;
  };

  _getBredcrumbs = () => {
    const { breadcrumbData } = this.state;
    return breadcrumbData.map((bc, index) => (
      <div className="assetmovetofolder-bredcrumb-item" key={bc.id}>
        <span
          className={`assetmovetofolder-bredcrumb-text ${this._activeBreadcrumbClassName(
            bc.id,
            index,
          )}`}
          onClick={() => this._handleBredcrumbClick(bc.id)}
          onKeyPress={() => {}}
          role="button"
          tabIndex="0">
          <Tooltip
            placement="top"
            align={{
              offset: [0, 4],
            }}
            overlay={`${bc.name}`}>
            <div>{bc.name ? truncateString(bc.name, 16, true) : null}</div>
          </Tooltip>
        </span>
        {index < breadcrumbData.length - 1 && (
          <FontAwesomeIcon
            icon={["far", "angle-right"]}
            className="assetmovetofolder-bredcrumb-icon"
          />
        )}
      </div>
    ));
  };

  _getFolderRow = (isCRMRootFolder, folderName) => (
    <div className="assetmovetofolder-selectfolder-col">
      {isCRMRootFolder ? (
        <span className="assetmovetofolder-icon-wrapper">
          <FontAwesomeIcon
            icon={["fal", "folder"]}
            className="assetmovetofolder-selectfolder-icon crm-folder-icon show-hover"
          />
          <FontAwesomeIcon
            icon={["fas", "folder"]}
            className="assetmovetofolder-selectfolder-icon crm-folder-icon hide-hover"
          />
          <FontAwesomeIcon
            icon={["far", "link"]}
            className="folder-link-icon"
          />
        </span>
      ) : (
        <Fragment>
          <FontAwesomeIcon
            icon={["fal", "folder"]}
            className="assetmovetofolder-selectfolder-icon folder-icon show-hover"
          />
          <FontAwesomeIcon
            icon={["fas", "folder"]}
            className="assetmovetofolder-selectfolder-icon folder-icon hide-hover"
          />
        </Fragment>
      )}

      <span className="assetmovetofolder-selectfolder-title">
        {folderName || "-"}
      </span>
    </div>
  );

  _getFolderList = () => {
    const { selectedBredcrumb, breadcrumbData } = this.state;
    let folderList = { children: [] };
    if (selectedBredcrumb) {
      folderList = selectedBredcrumb;
    } else if (breadcrumbData.length === 0) {
      folderList = { ...breadcrumbData[0] };
    } else if (breadcrumbData.length >= 1) {
      folderList = breadcrumbData[breadcrumbData.length - 1];
    }
    if (folderList.children && folderList.children.length > 0) {
      const { selectedItems } = this.props;
      const availableFolders = folderList.children.filter(
        child => !selectedItems.ids.find(item => item === child.id),
      );
      return availableFolders.map(folder => {
        const {
          opportunity_id: oppId,
          opportunity_root: OppRoot,
          access_level: accessLevel,
        } = folder;
        let isCRMRootFolder = false;
        if (oppId && OppRoot) {
          isCRMRootFolder = true;
        }
        const type = accessLevel === "EDIT" ? "MOVE" : null;
        const hasMovePermission = checkAssetPermission(accessLevel, type);
        if (hasMovePermission) {
          return (
            <div
              className="assetmovetofolder-selectfolder-row"
              onClick={() => this._handleFolderSelection(folder.id)}
              onKeyPress={() => {}}
              role="button"
              tabIndex="0"
              key={folder.id}>
              {this._getFolderRow(isCRMRootFolder, folder.name)}
            </div>
          );
        }
        return (
          <Tooltip
            placement="topLeft"
            overlay={
              "You don't have permission to move selected items in this folder"
            }
            align={{
              offset: [4, 0],
            }}>
            <div
              className="assetmovetofolder-selectfolder-row disable-move"
              key={folder.id}>
              {this._getFolderRow(isCRMRootFolder, folder.name)}
            </div>
          </Tooltip>
        );
      });
    }
    return null;
  };

  render() {
    const { showButtunLoader, selectedBredcrumb } = this.state;
    const { selectedItems } = this.props;
    let isBtnDisabled = false;
    if (selectedBredcrumb) {
      if (selectedBredcrumb.id === selectedItems.parentId) {
        isBtnDisabled = true;
      }
    }
    return (
      <Modal open onClose={this._closePopup} closeOnOverlayClick={false} center>
        {showButtunLoader && (
          <Loader className="loader-bg-color" label={MOVE_FOLDER} />
        )}
        <div
          className="assetmovetofolder-container"
          data-test="assetmovetofolder-container">
          {/* ---------- Modal Heading Section ---------- */}
          <div
            className="assetmovetofolder-modal-heading"
            data-test="assetmovetofolder-modal-heading">
            Move Selected Items
          </div>
        </div>

        {/* ---------- Bredcrumb Section ---------- */}
        <div className="assetmovetofolder-bredcrumb-wrapper">
          {this._getBredcrumbs()}
        </div>

        {/* ---------- Select Folder Section ---------- */}
        <div className="assetmovetofolder-folderlist-wrapper">
          {this._getFolderList()}
        </div>

        {/* ---------- Action Buttons Section ---------- */}
        <div className="createquotepopup-footer popup-footer">
          <div className="footer-actions">
            <Button
              className="btn btn-transparent createquotepopup-footer-cancelbtn"
              data-test="assetmovetofolder-movetofolder-cancel-button"
              onClick={this._closePopup}>
              Cancel
            </Button>
            <Button
              data-test="assetmovetofolder-movetofolder-button"
              disabled={isBtnDisabled}
              onClick={this._moveAssetItemsHandler}
              isLoading={showButtunLoader}>
              Move here
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const {
    assetFoldersTree,
    assetFolderContent,
    assetBreadcrumbData,
  } = state.AssetStore;
  return {
    assetFoldersTree,
    assetFolderContent,
    assetBreadcrumbData,
  };
};

const mapDispatchToProps = {
  moveToAssetItems: moveToAssetItemsAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssetMoveToFolderPopup);



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetDetails/AssetMoveToFolderPopup/index.js